<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <SecondaryButton
              v-on="on"
              v-bind="attrs"
              @click="viewTicket"
              btnClass="mr-2 rounded"
              icon="mdi-eye"
              iconClass=""
              x-small
            >
            </SecondaryButton>
          </template>
          <span>View Ticket</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <PrimaryButton
              x-small
              v-on="on"
              v-bind="attrs"
              v-if="params && params.data && params.data.is_status_changeable"
              @click="statusChange"
              btnClass="mr-2 rounded"
              iconClass=""
              icon="mdi-tag-arrow-up"
            >
            </PrimaryButton>
          </template>
          <span>Status Change</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    statusChange() {
      this.params.context.parentComponent.ticketStatus(this.params.data);
    },
    viewTicket() {
      this.$router.push({
        name: "support-user-ticket-view",
        params: {
          id: this.params.data.id,
        },
      });
    },
  },
};
</script>
